var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8334 10.8333C10.8334 11.2933 10.4601 11.6667 10.0001 11.6667C9.54009 11.6667 9.16675 11.2933 9.16675 10.8333V7.5C9.16675 7.04 9.54009 6.66667 10.0001 6.66667C10.4601 6.66667 10.8334 7.04 10.8334 7.5V10.8333ZM10.0001 14.1667C9.54009 14.1667 9.16675 13.7933 9.16675 13.3333C9.16675 12.8733 9.54009 12.5 10.0001 12.5C10.4601 12.5 10.8334 12.8733 10.8334 13.3333C10.8334 13.7933 10.4601 14.1667 10.0001 14.1667ZM18.8009 13.5858L12.4076 2.98667C11.9084 2.16 11.0084 1.66667 10.0001 1.66667C8.99176 1.66667 8.09176 2.16 7.59259 2.98667L1.19926 13.5858C0.725922 14.3717 0.711755 15.3167 1.16176 16.1133C1.64426 16.9692 2.58176 17.5 3.60676 17.5H16.3934C17.4184 17.5 18.3559 16.9692 18.8384 16.1133C19.2884 15.3167 19.2743 14.3717 18.8009 13.5858Z",
    fill: "current",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_2237",
    x1: 10.0001,
    y1: 1.66667,
    x2: 10.0001,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF2C2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.cd6404b87a07f7afe6e5f20ce9f6e6d6.svg";
export { ForwardRef as ReactComponent };